export default __webpack_public_path__ + "static/walkowski-e118ea53766be80e6346230f568d2f3a.jpg";